import { request } from './request'
import type { RoadmapMeta } from './types'

export const fetchMeta = async (): Promise<RoadmapMeta> =>
  request<RoadmapMeta>({ path: '/api/meta' })
